module.exports = __webpack_public_path__ + "img/yellow.52f67f14.jpg";